export default "__VITE_ASSET__DNQHTYBp__"